export default {"src":"/_next/static/media/两排字.1f872156.svg","height":40,"width":136};